var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfitArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 21.0566,
    height: 21.0566,
    rx: 10.5283,
    fill: "#419E6A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.48415 9.23919C7.22718 9.49616 6.81054 9.49616 6.55357 9.23919C6.2966 8.98222 6.2966 8.56558 6.55357 8.30861L10.063 4.79917C10.32 4.5422 10.7366 4.5422 10.9936 4.79917L14.503 8.30861C14.76 8.56558 14.76 8.98222 14.503 9.23919C14.246 9.49616 13.8294 9.49616 13.5724 9.23919L11.1863 6.85306L11.1863 15.3541C11.1863 15.7175 10.8917 16.0121 10.5283 16.0121C10.1649 16.0121 9.87027 15.7175 9.87027 15.3541L9.87027 6.85306L7.48415 9.23919Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfitArrowIcon);
export default __webpack_public_path__ + "static/media/ProfitArrowIcon.a35bf2cc149a1fe6e32e919f60b89f43.svg";
export { ForwardRef as ReactComponent };